import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";
import { ROLES_LIST } from "../roles/roles.config";
import {
  selectIsPreviewActive,
  selectPreviewRole,
  selectOriginPath,
  stopRolePreview,
} from "./rolePreviewSlice";

const ROLE_LABELS = {
  [ROLES_LIST.Mitglied]: "Mitglied",
  [ROLES_LIST.User]: "User",
  [ROLES_LIST.Editor]: "Editor",
  [ROLES_LIST.Admin]: "Admin",
};

export default function RolePreviewBanner() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isActive = useSelector(selectIsPreviewActive);
  const previewRole = useSelector(selectPreviewRole);
  const originPath = useSelector(selectOriginPath);

  if (!isActive) return null;

  const roleLabel = ROLE_LABELS[previewRole] || "Unbekannt";
  const isMemberView = previewRole === ROLES_LIST.Mitglied;

  const handleStop = () => {
    dispatch(stopRolePreview());
    navigate(originPath || "/dashboard/app");
  };

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1201,
        bgcolor: isMemberView ? "info.main" : "warning.main",
        color: isMemberView ? "info.contrastText" : "warning.contrastText",
        px: 2,
        py: 0.75,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <Iconify icon="mdi:eye-outline" width={20} sx={{ flexShrink: 0 }} />
      <Typography variant="body2" fontWeight="bold" sx={{ textAlign: "center" }}>
        {isMemberView ? "Mitgliedsansicht aktiv" : `Rollen-Vorschau aktiv: ${roleLabel}`}
      </Typography>
      <Typography variant="caption" sx={{ opacity: 0.9 }}>
        {isMemberView
          ? "Sie nutzen jetzt die Mitglieds-Journey."
          : "Bereiche werden entsprechend der Vorschau-Rolle angezeigt."}
      </Typography>
      <Button
        size="small"
        variant="contained"
        color="inherit"
        sx={{
          color: isMemberView ? "info.dark" : "warning.dark",
          fontWeight: "bold",
          ml: 1,
        }}
        startIcon={<Iconify icon="mdi:arrow-left" width={18} />}
        onClick={handleStop}
      >
        {isMemberView ? "Zurück zur Mitarbeiteransicht" : "Vorschau beenden"}
      </Button>
    </Box>
  );
}
